import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Bestätigungsdialog: Zeile in Vorderseite löschen (Arbeitsgegenstand/Mitarbeiter/Betriebsmittel/Zusammenstellung).
 *
 * Technischer Extract aus App.jsx (Plan A): UI/Keys 1:1, Logik bleibt in App.jsx (onConfirm).
 */
function VorderseiteRowDeleteDialog({ data, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!data) return null;

  const { type, row } = data;

  return (
    <div className="edit-overlay" onClick={onCancel}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-header">
          <h3>⚠️ {t('dialog.row_delete.title')}</h3>
          <button className="btn-close" onClick={onCancel} type="button">×</button>
        </div>
        <div className="edit-content">
          <p style={{ fontSize: '1rem', color: '#374151', lineHeight: '1.6' }}>
            {t('vorderseite.row_delete.confirm')}
          </p>
          <div className="edit-info" style={{ marginTop: '16px' }}>
            {type === 'arbeitsgegenstand' && (
              <>
                {row?.bennenung && (
                  <div>
                    <strong>{t('vorderseite.arbeitsgegenstand.benennung')}:</strong> {row.bennenung}
                  </div>
                )}
                {row?.material && (
                  <div>
                    <strong>{t('vorderseite.arbeitsgegenstand.material')}:</strong> {row.material}
                  </div>
                )}
                {row?.zeichn_nr && (
                  <div>
                    <strong>{t('vorderseite.arbeitsgegenstand.zeichn_nr')}:</strong> {row.zeichn_nr}
                  </div>
                )}
              </>
            )}

            {type === 'mitarbeiter' && (
              <>
                {row?.name && (
                  <div>
                    <strong>{t('vorderseite.mitarbeiter.name')}:</strong> {row.name}
                  </div>
                )}
                {row?.pers_nr && (
                  <div>
                    <strong>{t('vorderseite.mitarbeiter.pers_nr')}:</strong> {row.pers_nr}
                  </div>
                )}
              </>
            )}

            {type === 'betriebsmittel' && (
              <>
                {row?.bennenung_type && (
                  <div>
                    <strong>{t('vorderseite.betriebsmittel.benennung_type')}:</strong> {row.bennenung_type}
                  </div>
                )}
                {row?.betrieb_nr && (
                  <div>
                    <strong>{t('vorderseite.betriebsmittel.betrieb_nr')}:</strong> {row.betrieb_nr}
                  </div>
                )}
              </>
            )}

            {type === 'zusammenstellung' && (
              <>
                {row?.art && (
                  <div>
                    <strong>{t('vorderseite.zusammenstellung.art')}:</strong> {row.art}
                  </div>
                )}
                {row?.zeit_min !== undefined && row?.zeit_min !== null && (
                  <div>
                    <strong>{t('vorderseite.zusammenstellung.zeit_min')}:</strong> {row.zeit_min}
                  </div>
                )}
                {row?.herkunft && (
                  <div>
                    <strong>{t('vorderseite.zusammenstellung.herkunft')}:</strong> {row.herkunft}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <div className="edit-actions">
          <button className="btn btn-danger" onClick={onConfirm} type="button">
            {t('dialog.delete')}
          </button>
          <button className="btn btn-secondary" onClick={onCancel} type="button">
            {t('dialog.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default VorderseiteRowDeleteDialog;

